const actions = {
  // download file with the results stored in the database
  async downloadFileBackoffice(context, queryParams) {
    try {
      // send the GET request to return the file
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/backoffice/download?${queryParams}`,
        {
          method: 'GET',
        }
      );

      // if an error occured, return it
      if (!response.ok) {

        // get the error
        const errorData = await response.json();

        // throw the error to be displayed
        if (errorData && errorData.error) {
          throw new Error(errorData.error);

        // if the error contains field 'errors.token' we know it's because no token was passed
        } else if (errorData && errorData.errors.token){
          console.log(errorData.errors.token)
          throw new Error('É necessário fornecer um token de acesso.');
        }
      }

      // if the requets did not result in an error, return the file
      const blob = await response.blob();

      // Generate a timestamp in the format YYYYmmDD_hhMMss to add to the file name
      const now = new Date();
      const timestamp = now.toISOString().replace(/[-:]/g, '').replace('T', '_').slice(0, 15);

      // Create a URL for the file
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `RNCIQ_Autodiagnostico_Backoffice_Results_${timestamp}.zip`); // Set the file name with the timestamp
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    // return the error thrown previously
    } catch (error) {
      return error.message;
    }
  },
};

export default {
  namespaced: true,
  actions,
};